module.exports = __webpack_public_path__ + "static/media/country_bf.c3ea1bbc.webp";